type Side = { name: string; score: number; done: number; away?: boolean };

export function Scoreboard({ me, opponent, total }: { me: Side; opponent: Side; total: number }) {
  return (
    <div className="scoreboard">
      <div className="score-side">
        <div className="score-name">{me.name}</div>
        <div className="score-value">{me.score}</div>
        <Segments filled={me.done} total={total} />
      </div>

      <div className="versus">vs</div>

      <div className="score-side score-side-right">
        <div className="score-name">
          {opponent.name}
          {opponent.away && <span className="score-away"> · reconnecting…</span>}
        </div>
        <div className="score-value">{opponent.score}</div>
        <Segments filled={opponent.done} total={total} opponent />
      </div>
    </div>
  );
}

function Segments({
  filled,
  total,
  opponent = false,
}: {
  filled: number;
  total: number;
  opponent?: boolean;
}) {
  return (
    <div className={opponent ? "segments segments-opp" : "segments"} aria-hidden="true">
      {Array.from({ length: total }, (_, i) => (
        <i key={i} className={i < filled ? "on" : undefined} />
      ))}
    </div>
  );
}
